import React from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";

// Camps
import { useGetStatementsQuery } from "../../services/AccountCharts";
import {
  setVendorStatementError,
  setVendorStatementLoading,
  setVendorStatement,
} from "../../store/slices/vendorsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);
  const vendorChange = useAppSelector((state) => state.common.vendorChange);
  // States
  const state = useAppSelector((state) => state.vendors);

  // **************
  // **************
  // Get All Payment Ids
  // **************
  // **************
  const {
    data: allVendorStatement,
    isLoading: statementIdsLoading,
    isError: statementIdsError,
    refetch: statementIdsRefetch,
  } = useGetStatementsQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: profileData.permissions.showEmployee || false,
    vendorID: state.vendorIdNo,
    fromDate: new Date(state.statementFrom).toLocaleDateString(),
    toDate: new Date(state.statementTo).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (statementIdsLoading) {
      dispatch(setVendorStatementLoading(true));
    }
    if (statementIdsError) {
      dispatch(setVendorStatementError("Something went wrong"));
      dispatch(setVendorStatementLoading(false));
    }
    if (allVendorStatement) {
      dispatch(setVendorStatement(allVendorStatement.data.statement || []));
      dispatch(setVendorStatementLoading(false));
    }
  }, [
    accessToken,
    userID,
    allVendorStatement,
    profileData,
    state.vendorIdNo,
    state.statementFrom,
    state.statementTo,
  ]);
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    statementIdsRefetch();
  }, [vendorChange, state.vendorIdNo, state.statementFrom, state.statementTo]);
  return <></>;
};
export default Content;
